import { getMomentTz } from "@dexteel/mesf-core";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Box, Button, Tooltip, Typography } from "@mui/material";

const moment = getMomentTz();

export const ActionCard = ({
	action,
	comments,
	lastUpdate,
	onPressed,
}: {
	action: string;
	comments: string | null | undefined;
	lastUpdate: Date | null;
	onPressed: () => void;
}) => {
	const hasBeenDone = lastUpdate !== null;

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: 1,
				p: 1.5,
				borderRadius: 1,
				backgroundColor: "#fafafa",
				"&:hover": {
					backgroundColor: "#f5f5f5",
				},
			}}
			data-test-id={action.replaceAll(" ", "_").toLowerCase()}
		>
			{hasBeenDone ? (
				<CheckCircleIcon sx={{ color: "#4caf50", fontSize: 20 }} />
			) : (
				<RadioButtonUncheckedIcon sx={{ color: "#bdbdbd", fontSize: 20 }} />
			)}

			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Tooltip
					title={`Comments: ${comments}` || ""}
					arrow
					placement="top"
					disableHoverListener={!comments}
				>
					<Typography
						variant="body2"
						fontWeight={500}
						sx={{
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap",
						}}
					>
						{action}
					</Typography>
				</Tooltip>
				<Typography variant="caption" color="textSecondary">
					{hasBeenDone
						? `Last record: ${moment(lastUpdate).format("MM/DD/YY")}`
						: "No records"}
				</Typography>
			</Box>

			<Button
				variant="outlined"
				size="small"
				onClick={() => onPressed()}
				sx={{
					textTransform: "none",
					fontWeight: 500,
					minWidth: "auto",
					px: 1.5,
				}}
				data-test-id="record"
			>
				Record
			</Button>
		</Box>
	);
};
